module.exports = ".alto-modal{\r\n    height: auto!important;\r\n}\r\n\r\n.wrapper {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    margin-bottom: 5px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modalmoverevidencia/modalmoverevidencia.component.css
// module id = ./src/app/modalmoverevidencia/modalmoverevidencia.component.css
// module chunks = main